import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-group-students-to-add",
	templateUrl: "./group-students-to-add.component.html",
	styleUrls: ["./group-students-to-add.component.css"],
})
export class GroupStudentsToAddComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() RemoveAll: EventEmitter<any> = new EventEmitter();
	@Output() RemovePerson: EventEmitter<any> = new EventEmitter();

	///////////////
	// Built-In
	///////////////

	pagerows: any = 10;
	pagefirst: any = 0;
	@Input() loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPerson: any;
	@Input() lstPerson: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentID", header: "Student ID" },
		{ field: "LastName", header: "Last Name" },
		{ field: "FirstName", header: "First Name" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRemoveAll() {
		this.RemoveAll.emit(true);
	}

	onRemove(Person) {
		this.onRowUnselect(null);
		this.RemovePerson.emit(Person);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedPerson = val.data;
	}
	onRowUnselect(val) {
		this.SelectedPerson = null;
	}
	onRowDblClick(Person) {
		this.SelectedPerson = Person;
	}
	////////////////////////////////////////////
}
